import template from './bChartShareDialog.html';
import { entryToName } from '../p360ViewManager/bShareModal/chartNaming';

export function bChartShareDialogDirective() {
  'ngInject';

  return {
    restrict: 'E',
    template: template,
    controller: bChartShareDialogController,
    controllerAs: 'bChartShareDialog',
    bindToController: true,
    scope: {
      data: "=",
      onClose: "&"
    }
  };
}

class bChartShareDialogController {
  constructor(API, Clients, $translate, $rootScope) {
    'ngInject';

    this.API = API;
    this.Clients = Clients;
    this.state = '';
    this.step = 1;
    this.saveName = false;
    this.name = '';
    this.enableExport = true;
    this.showWorklog = true;
    this.showChart = true;
    this.$translate = $translate;
    this.$rootScope = $rootScope;
    this.$rootScope.$watch(() => this.data, () => {
      this.name = entryToName({
        chartDataType: this.data.type,
        clientIds: this.data.selectedClientsRich.map(c => c.id),
        teamIds: this.data.selectedTeamsRich.map(t => t.id),
        dominantClientView: { clientName: this.data.selectedClientsRich[0] ? this.data.selectedClientsRich[0].name : undefined },
        dominantTeamView: { teamName: this.data.selectedTeamsRich[0] ? this.data.selectedTeamsRich[0].name : undefined },
        hasAllClientsForGivenSpan: this.data.hasAllClientsForGivenSpan,
        hasAllTeamsForGivenSpan: this.data.hasAllTeamsForGivenSpan
      });
    });
  }

  copyLink() {
    const text = document.getElementById('bChartShareDialog_link');
    const textArea = document.createElement("textarea");
    textArea.value = text.textContent;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("Copy");
    textArea.remove();

    let tooltip = document.getElementById("myTooltip");
    tooltip.innerHTML = this.$translate.instant("VIEW360.COPIED");
  }

  closeDialog() {
    this.onClose({});
  }

  enableGetLinkButton() {
    if (this.showChart === false && this.showWorklog === false)
      return true;
    else
      return false;
  }

  getLink() {
    const apiData = {
      type: this.data.type,
      currency: this.data.currency,
      currencyRatio: this.data.currencyRatio,
      chartData: this.data.chartData,
    };

    const showChart = this.showChart;

    const shareScope = {
      value: null,  //All extends ValueScope case object Va extends ValueScope case object Nva
      processGroup: null,
      processName: null,
      seniorityLevel:  null,
      processProblems: null,
      showChart: showChart
    };

    let chartType = "ProcessGroups";

    let allowedColumns = [];
    let filteredApiData =  angular.copy(apiData.chartData);

    if(this.$rootScope.processGroupChartWithLegend === undefined)
      this.$rootScope.processGroupChartWithLegend = null;

    const legendToggleGroupChart = this.$rootScope.toggleValueProcessGroupChart;
    const legendToggleVaAndNvaChart = this.$rootScope.toggleValueVaAndNvaChart;

    const NvaDataPg =  angular.copy(this.$rootScope.chartDataNva);
    const VaDataPg =  angular.copy(this.$rootScope.chartDataVa);

    const VaAndNvaCharData = angular.copy(this.$rootScope.bVaAndNvaCharData);

    if (apiData.type === 'va_processes') {
      shareScope.value = 'Va';
      allowedColumns = ['VaDuration'];
      shareScope.processGroup = this.$rootScope.selectedProcessGroup;
      filteredApiData = VaDataPg.map((x) => {
        x.nvaDuration = 'PT0S';
        return x;
      });
    }

    if(apiData.type === 'nva_processes'){
      shareScope.value = 'Nva';
      allowedColumns = ['NvaDuration'];
      shareScope.processGroup = this.$rootScope.selectedProcessGroup;
      filteredApiData = NvaDataPg.map((x) => {
        x.vaDuration = 'PT0S';
        return x;
      });
    }

    if(apiData.type === 'process_group'){

      if (legendToggleGroupChart === 'All') {
        shareScope.value = 'All';
        allowedColumns = ['NvaDuration', 'VaDuration'];
      }
      if (legendToggleGroupChart === 'Nva') {
        shareScope.value = 'Nva';
        allowedColumns = ['NvaDuration'];
      }
      if (legendToggleGroupChart === 'Va') {
        shareScope.value = 'Va';
        allowedColumns = ['VaDuration'];
      }


      filteredApiData = filteredApiData.map((x) => {
        if(legendToggleGroupChart === 'All')
          return x;
        if(legendToggleGroupChart === 'Nva'){
          x.vaDuration = 'PT0S';
          return x;
        }
        if(legendToggleGroupChart === 'Va'){
          x.nvaDuration = 'PT0S';
          return x;
        }
      });
    }

    if(apiData.type === 'prof_and_hour_rate'){
      //chartType = 'Profitability';
      shareScope.value = 'All';
      filteredApiData = this.$rootScope.dataLinePlusBarChart.map((x) => {
        return x;
      });
    }

    if(apiData.type === 'va_and_nva'){
      if(legendToggleVaAndNvaChart === 'All' || legendToggleVaAndNvaChart === undefined){
        shareScope.value = 'All';
        allowedColumns = ['NvaDuration', 'VaDuration'];
      }
      if(legendToggleVaAndNvaChart === 'Nva'){
        shareScope.value = 'Nva';
        allowedColumns = ['NvaDuration'];
      }
      if(legendToggleVaAndNvaChart === 'Va'){
        shareScope.value = 'Va';
        allowedColumns = ['VaDuration'];
      }

      filteredApiData = VaAndNvaCharData.map((x) => {
        if(legendToggleVaAndNvaChart === 'All' || legendToggleVaAndNvaChart === undefined)
          return x;
        if(legendToggleVaAndNvaChart === 'Nva'){
          x.vaDuration = 'PT0S';
          return x;
        }
        if(legendToggleVaAndNvaChart === 'Va'){
          x.nvaDuration = 'PT0S';
          return x;
        }
      });
    }

    if(apiData.type === 'process_problems'){
      shareScope.value = 'All';
      allowedColumns = ['NvaDuration', 'VaDuration'];

      shareScope.processProblems = this.$rootScope.dataProcessProblemChartProcessProblems;
      filteredApiData = this.$rootScope.dataProcessProblemChart;

    }

    if(apiData.type === 'employee_role'){
      shareScope.value = 'All';
      allowedColumns = ['NvaDuration', 'VaDuration'];
      shareScope.seniorityLevel = this.$rootScope.dataProcessRoles;
      filteredApiData = this.$rootScope.dataProcessRoleChart;
    }

    if(apiData.type === 'vol_slicer_table'){
      shareScope.value = 'All';

      filteredApiData = this.$rootScope.dataVolSlicerChart;
      filteredApiData = {
        ...filteredApiData,
        showZero: this.$rootScope.dataVolSlicerChartshowZero
      };
    }

    if(apiData.type === 'vol_slicer_hours' || apiData.type === 'vol_slicer_volume'){
      shareScope.value = 'All';
      filteredApiData =  this.$rootScope.dataVolSlicerHoursvolumeChart;
    }

    if(apiData.type === 'all'){
      shareScope.value = 'All';
    }

    let apiDataCopy = angular.copy(apiData);

    apiDataCopy.chartData = filteredApiData;

    if(apiData.type === 'process_problems'){
      apiDataCopy = {
        ...apiDataCopy,
        processProblems: shareScope.processProblems
      };
    }

    if(apiData.type === 'employee_role'){
      apiDataCopy = {
        ...apiDataCopy,
        seniorityLevel: shareScope.seniorityLevel
      };
    }
    this.state = "loading";

    this.Clients.shareChartData(
      this.data.startDate,
      this.data.endDate,
      apiDataCopy,
      this.data.selectedClients,
      this.data.selectedTeamsSelected,
      this.showWorklog && this.enableExport,
      this.showWorklog,
      shareScope,
      chartType,
      allowedColumns,
      showChart,
      this.name
    ).then(res => {
      if (res.status !== 201) {
        this.state = "loaded";
        return;
      }
      const configId = res.data.id;
      this.link = `${this.API.shareUrl}/stats/management/360-view/shared/${configId}`;
      this.state = "loaded";
      this.step = 2;
    }, () => {
      this.state = "error";
    });
  }
}
